import { createNavigationView } from './index'

const Admin = () => import('../components/Admin/Admin.vue')
const AdminSidebar = () => import('../components/Admin/AdminSidebar.vue')
const EmailTemplates = () => import('../components/Admin/EmailTemplates/EmailTemplates.vue')

const Users = () => import('../components/Admin/Users/Users.vue')
const DeleteUserModal = () => import('../components/Admin/Users/DeleteUserModal.vue')

const Adverts = () => import('../components/Admin/Adverts/Adverts.vue')
const AdvertDetailsModal = () => import('../components/Admin/Adverts/AdvertDetailsModal.vue')
const DeleteAdvertModal = () => import('../components/Admin/Adverts/DeleteAdvertModal.vue')

const BidCards = () => import('../components/Admin/BidCards/BidCards.vue')
const DeleteBidCardModal = () => import('../components/Admin/BidCards/DeleteBidCardModal.vue')

const Occupations = () => import('../components/Admin/Occupations/Occupations.vue')
const ReassignOccupationModal = () => import('../components/Admin/Occupations/ReassignOccupationModal.vue')
const EmployerSearch = () => import('../components/Admin/EmployerSearch/EmployerSearch.vue')

const Newsletters = () => import('../components/Admin/Newsletters/Newsletters')
const EditNewsletter = () => import('../components/Admin/Newsletters/EditNewsletter')
const DeleteNewsletterModal = () => import('../components/Admin/Newsletters/DeleteNewsletterModal')
const PreviewNewsletterModal = () => import('../components/Admin/Newsletters/PreviewNewsletterModal')
const DispatchNewsletterModal = () => import('../components/Admin/Newsletters/DispatchNewsletterModal')
const AbortNewsletterModal = () => import('../components/Admin/Newsletters/AbortNewsletterModal')

const Holidays = () => import('../components/Admin/Calendar/Holidays.vue')
const Exports = () => import('../components/Admin/Exports/Exports.vue')

export const routes = () => [
  {
    path: '/admin',
    components: {
      default: Admin,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    meta: {
      pageTitle: 'Admin',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/email-sablonok',
    components: {
      default: EmailTemplates,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    meta: {
      pageTitle: 'Admin - Email Templates',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/felhasznalok',
    components: {
      default: Users,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    children: [
      {
        path: ':id/torles',
        component: DeleteUserModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Admin - Users - Delete',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Admin - Users',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/hirdetesek',
    components: {
      default: Adverts,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    children: [
      {
        path: ':id/torles',
        component: DeleteAdvertModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Admin - Ads - Delete',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id',
        component: AdvertDetailsModal,
        props: route => ({ id: route.params.id }),
        meta: {
          isModal: true,
          pageTitle: 'Admin - Ads - Details',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Admin - Ads',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/ajanlati-kartyak',
    components: {
      default: BidCards,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    children: [
      {
        path: ':id/torles',
        component: DeleteBidCardModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Admin - Bid Cards - Delete',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Admin - Bid Cards',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/munkakorok',
    components: {
      default: Occupations,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    children: [
      {
        path: ':id/atrendeles',
        component: ReassignOccupationModal,
        props: route => ({
          id: route.params.id,
          occupation: route.query.occupation
        }),
        meta: {
          isModal: true,
          pageTitle: 'Admin - Occupations - Reassign',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Admin - Occupations',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/munkaadoi-keresesek',
    components: {
      default: EmployerSearch,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    meta: {
      pageTitle: 'Admin - Employer Searches',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/hirlevelek',
    components: {
      default: Newsletters,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    children: [
      {
        path: ':id/torles',
        component: DeleteNewsletterModal,
        props: route => ({ id: +route.params.id }),
        meta: {
          isModal: true,
          pageTitle: 'Admin - Newsletter - Delete',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/elonezet',
        component: PreviewNewsletterModal,
        props: route => ({ id: +route.params.id }),
        meta: {
          isModal: true,
          pageTitle: 'Admin - Newsletter - Preview',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/kezbesites',
        component: DispatchNewsletterModal,
        props: route => ({ id: +route.params.id }),
        meta: {
          isModal: true,
          pageTitle: 'Admin - Newsletter - Dispatch',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/megszakitas',
        component: AbortNewsletterModal,
        props: route => ({ id: +route.params.id }),
        meta: {
          isModal: true,
          pageTitle: 'Admin - Newsletter - Abort',
          requiresAdmin: true,
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Admin - Newsletters',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/hirlevelek/uj-hirlevel',
    components: {
      default: EditNewsletter,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    meta: {
      pageTitle: 'Admin - New newsletter',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/hirlevelek/:id/modositas',
    components: {
      default: EditNewsletter,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    props: {
      default: route => ({ id: +route.params.id })
    },
    meta: {
      pageTitle: 'Admin - Edit newsletter',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/unnepnapok',
    components: {
      default: Holidays,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    meta: {
      pageTitle: 'Admin - Holidays',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/admin/listak-exportalasa',
    components: {
      default: Exports,
      navigation: createNavigationView('static'),
      sidebar: AdminSidebar
    },
    meta: {
      pageTitle: 'Admin - Exports',
      requiresAdmin: true,
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin.js